import { type QueryClient } from "@tanstack/react-query";

export function invalidateWorkplaceChargeLeadTimeDifferentialsQueries(
  queryClient: QueryClient,
  workplaceId: string
): void {
  void queryClient.invalidateQueries({
    predicate: (query) => {
      const [url] = query.queryKey;
      return (
        typeof url === "string" &&
        url.includes(`/workplaces/${workplaceId}/charge-lead-time-differentials`)
      );
    },
  });
}
